import ConnectEtsyShop from './ConnectEtsyShop.vue';

export default ConnectEtsyShop;
